/***
 * 
 * Dropdown List
 * 
 */

import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import * as actions from '../../../store/actions/index';
import { DROPDOWN_CONFIG } from '../../Config';

class DropdownList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { }
    }

    componentDidMount() {
        const { loggedUserDetail, getKeywordValues, fetchSubordinatesLists } = this.props;
        const hrTeam = parseInt(localStorage.getItem('hrTeam'));
      
        if (hrTeam)
            getKeywordValues('Employee');
        else
            fetchSubordinatesLists(loggedUserDetail.empID, loggedUserDetail.CompanyId);
        
    }

    render() {

        const { keywordValuesList, subordinatesListData, loggedUserDetail, name, placeholder, value, onDropdownChange } = this.props;
        const hrTeam = parseInt(localStorage.getItem('hrTeam'));

        let relevantOptions = [];
        if (hrTeam) {
            relevantOptions = keywordValuesList.reduce((a, el) => {
                if (el.uniqueId !== loggedUserDetail.empID) {
                    a.push(el);
                }
                return a;
            }, [Object.assign({}, keywordValuesList.find(list => list.uniqueId === loggedUserDetail.empID), {label: 'Self'})]);
        } else {
            relevantOptions = loggedUserDetail ? [{label: `${loggedUserDetail.userName} (self)`, value: loggedUserDetail.empID}].concat(subordinatesListData) : subordinatesListData;
        }

        return (<Dropdown
        name={name}
        className="p-col-12 p-md-8 p-lg-8"
        placeholder={placeholder}
        value={value}
        options={relevantOptions}
        onChange={onDropdownChange}
        filter={true}
        autoWidth={false} 
        {...DROPDOWN_CONFIG} />)
    }

}



const mapStateToProps = (state) => {
    return {
        loggedUserDetail: state.auth.userObject,
        keywordValuesList: state.master.keywordValuesList,
        subordinatesListData: state.master.subordinatesListData
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value))
    }
};



export default connect(mapStateToProps, mapDispatchToProps)(DropdownList);